<template>
  <div class="checkboxes-wrapper checkboxes-wrapper--single" :class="{ 'error': showFormError,  'required': required }">
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <label class="checkbox-container">
      <input type="checkbox"
        id="checkbox--terms"
        name="checkbox--terms"
        v-model="value">
      <span class="checkmark"></span>
      <span class="checkbox__title" v-html="termsContent"/>
    </label>
    <p class="forms__error-message" v-if="showFormError" v-t="'errors.required_field'" role="alert"/>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";

export default {
  name: 'terms-of-service',
  mixins: [AbstractField],
  computed: {
    termsContent() {
      return this.$t('message.privacy_policy')
    }
  },
}
</script>